import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import SeminarForm from "../_components/SeminarForm";
import styles from "../Notice.module.css";
import apiService from "../../../../services/api";
import { setupAutoLogout } from "../../../../utils/auth";

export default function FormClient() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id'); // 수정 모드인지 확인
    const [seminarData, setSeminarData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // 인증 확인 및 자동 로그아웃 설정
    useEffect(() => {
        if (!apiService.isAuthenticated()) {
            navigate("/admin/login");
            return;
        }

        // 토큰 만료 시 자동 로그아웃 설정
        const cleanup = setupAutoLogout(() => {
            console.log('Seminar form auto logout triggered');
            navigate("/admin/login");
        });

        // API 서비스에 토큰 만료 콜백 등록
        apiService.setTokenExpiredCallback(() => {
            console.log('Seminar form API service token expired callback');
            navigate("/admin/login");
        });

        return cleanup;
    }, [navigate]);
    
    // 수정 모드일 때 기존 데이터 가져오기
    useEffect(() => {
        if (id) {
            const fetchSeminarData = async () => {
                setLoading(true);
                try {
                    const response = await apiService.getSeminarById(id);
                    setSeminarData(response);
                } catch (error) {
                    console.error('세미나 & 컨퍼런스 데이터 가져오기 실패:', error);
                    alert('세미나 & 컨퍼런스 정보를 가져오는데 실패했습니다.');
                    navigate("/admin/notices?tab=seminar");
                } finally {
                    setLoading(false);
                }
            };
            
            fetchSeminarData();
        }
    }, [id, navigate]);
    
    const handleSubmit = () => {
        // 성공 후 세미나 & 컨퍼런스 탭으로 돌아가기
        navigate("/admin/notices?tab=seminar");
    };
    
    const handleCancel = () => {
        // 취소 시 세미나 & 컨퍼런스 탭으로 돌아가기
        navigate("/admin/notices?tab=seminar");
    };

    if (loading) {
        return (
            <div className={styles.noticeWrap}>
                <div className={styles.SubPageWidth}>
                    <div className={styles.header}>
                        <h1>세미나 & 컨퍼런스 수정</h1>
                        <button onClick={handleCancel} className={styles.backBtn}>
                            목록으로
                        </button>
                    </div>
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        데이터를 불러오는 중...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.noticeWrap}>
            <div className={styles.SubPageWidth}>
                <div className={styles.header}>
                    <h1>{id ? "세미나 & 컨퍼런스 수정" : "세미나 & 컨퍼런스 등록"}</h1>
                    <button onClick={handleCancel} className={styles.backBtn}>
                        목록으로
                    </button>
                </div>
                
                <SeminarForm 
                    item={seminarData}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
}

